import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { heroSlides } from '../data/company';
import Icon from '../components/Icon';

// Decorative backdrop (stands in for the reference's photographic background).
function Backdrop() {
  return (
    <svg className="hero__art" viewBox="0 0 800 800" aria-hidden="true" preserveAspectRatio="xMidYMid slice">
      <g fill="none" stroke="#80c342" strokeOpacity=".35">
        {[90, 150, 210, 270, 330].map((r) => (
          <circle key={r} cx="520" cy="400" r={r} strokeDasharray={r % 2 ? '4 10' : '0'} />
        ))}
        <path d="M520 70v120M520 610v120M190 400h120M730 400h120M285 165l80 80M755 635l-80-80M285 635l80-80M755 165l-80 80" />
      </g>
      <g fill="#80c342">
        <circle cx="520" cy="400" r="8" /><circle cx="365" cy="245" r="5" /><circle cx="675" cy="555" r="5" /><circle cx="190" cy="400" r="4" /><circle cx="850" cy="400" r="4" />
      </g>
    </svg>
  );
}

export default function Hero() {
  const navigate = useNavigate();
  const [i, setI] = useState(0);
  const n = heroSlides.length;

  useEffect(() => {
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || n < 2) return undefined;
    const t = setTimeout(() => setI((v) => (v + 1) % n), 7000);
    return () => clearTimeout(t);
  }, [i, n]);

  const s = heroSlides[i];
  return (
    <section id="home" className="hero">
      <div className="hero__grid-bg" />
      <Backdrop />
      <div className="container hero__inner">
        <div className="hero__text" key={i}>
          <h1>{s.title}</h1>
          <p>{s.text}</p>
          <div className="hero__actions">
            <button className="btn btn--primary" onClick={() => navigate('/contact')}>
              Get In Touch <Icon name="arrow" size={18} />
            </button>
            <button className="btn btn--ghost" onClick={() => navigate('/services')}>
              Explore Our Services
            </button>
          </div>
        </div>
      </div>
      {n > 1 && (
        <div className="hero__ctrl">
          <button aria-label="Previous slide" onClick={() => setI((i + n - 1) % n)}><Icon name="arrow" size={16} className="flip" /></button>
          <div className="hero__dots">
            {heroSlides.map((_, k) => (
              <button key={k} aria-label={`Slide ${k + 1}`} className={k === i ? 'is-on' : ''} onClick={() => setI(k)} />
            ))}
          </div>
          <button aria-label="Next slide" onClick={() => setI((i + 1) % n)}><Icon name="arrow" size={16} /></button>
        </div>
      )}
    </section>
  );
}
